module.exports = __webpack_public_path__ + "img/logo.828ae7eb.png";